import {Image} from 'primereact/image'
import {ReactComponent as AiFillAlert} from '../assets/icons/AiFillAlert.svg'
import {ReactComponent as AiOutlineLineChart} from '../assets/icons/AiOutlineLineChart.svg'
import {ReactComponent as BsFillEmojiDizzyFill} from '../assets/icons/BsFillEmojiDizzyFill.svg'
import {ReactComponent as EcgIcon} from '../assets/icons/EcgIcon.svg'
import {ReactComponent as FaChartArea} from '../assets/icons/FaChartArea.svg'
import {ReactComponent as FaHeartbeat} from '../assets/icons/FaHeartbeat.svg'
import {ReactComponent as FaTemperatureHigh} from '../assets/icons/FaTemperatureHigh.svg'
import {ReactComponent as GiMuscleFat} from '../assets/icons/GiMuscleFat.svg'
import {ReactComponent as GiNightSleep} from '../assets/icons/GiNightSleep.svg'
import {ReactComponent as ImConfused} from '../assets/icons/ImConfused.svg'
import {ReactComponent as ChatIcon} from '../assets/icons/IoChatBubbles.svg'
import {ReactComponent as IoFootSteps} from '../assets/icons/IoFootSteps.svg'
import {ReactComponent as MdBloodtype} from '../assets/icons/MdBloodtype.svg'
import {ReactComponent as MdSick} from '../assets/icons/MdSick.svg'
import {ReactComponent as RiWindyFill} from '../assets/icons/RiWindyFill.svg'
import {ReactComponent as SiOxygen} from '../assets/icons/SiOxygen.svg'
import {ReactComponent as Systolic} from '../assets/icons/Systolic.svg'
export const headerNotificationList = (size, mr) => {
    let iconsSize = size ? size : '24px'
    // let iconMr = mr ? mr : ''
    return {
        news: {
            icon: (
                <FaChartArea
                    style={{
                        height: iconsSize,
                        width: iconsSize,
                        color: '#77037B',
                    }}
                    className="mr-1"
                />
            ),
            label: 'NEWS2',
        },
        tas: {
            icon: (
                <AiOutlineLineChart
                    style={{
                        height: iconsSize,
                        width: iconsSize,
                        color: '#57C5B6',
                    }}
                    className="mr-1"
                />
            ),
            label: 'TAS',
        },
        emergency: {
            icon: (
                <AiFillAlert
                    style={{
                        height: iconsSize,
                        width: iconsSize,
                        color: '#D21312',
                    }}
                    className="mr-1"
                />
            ),
            label: 'EMERGENCY',
        },
        fall: {
            icon: (
                <Image
                    src={require(`.././assets/icons/fall.jpg`)}
                    alt="Avatar"
                    width="22"
                    className="border-circle mr-1"
                />
            ),
            label: 'FALL',
        },
        symptom: {
            icon: (
                <MdSick
                    style={{
                        height: iconsSize,
                        width: iconsSize,
                        color: '#88C273',
                    }}
                    className="mr-1"
                />
            ),
            label: 'SYMPTOM',
        },
        conversation: {
            icon: (
                <ChatIcon
                    style={{
                        height: iconsSize,
                        width: iconsSize,
                        color: 'darkcyan',
                    }}
                    className="mr-1"
                />
            ),
            label: 'CONVERSATIONS',
        },
        ecg: {
            icon: (
                <EcgIcon
                    style={{
                        height: iconsSize,
                        width: iconsSize,
                        color: '#88C273',
                    }}
                    className="mr-1"
                />
            ),
            label: 'ECG',
        },
        seizure: {
            icon: (
                <Image
                    src={require(`.././assets/icons/seizure.jpg`)}
                    alt="Avatar"
                    width="25"
                    className="border-circle mr-1"
                />
            ),
            label: 'SEIZURE',
        },
        heartRate: {
            icon: (
                <FaHeartbeat
                    style={{
                        height: iconsSize,
                        width: iconsSize,
                        color: '#ED2B2A',
                    }}
                />
            ),
            label: 'HEART RATE',
        },

        respiration: {
            icon: (
                <RiWindyFill
                    style={{
                        height: iconsSize,
                        width: iconsSize,
                        color: '#03C988',
                    }}
                />
            ),
            label: 'EMERGENCY',
        },
        oxygen: {
            icon: (
                <SiOxygen
                    style={{
                        height: iconsSize,
                        width: iconsSize,
                        color: '#0081B4',
                    }}
                />
            ),
            label: 'EMERGENCY',
        },
        temperature: {
            icon: (
                <FaTemperatureHigh
                    style={{
                        height: iconsSize,
                        width: iconsSize,
                        color: '#FC7300',
                    }}
                />
            ),
            label: 'EMERGENCY',
        },
        bloodPressure: {
            icon: (
                <MdBloodtype
                    style={{
                        height: iconsSize,
                        width: iconsSize,
                        color: '#CD0404',
                    }}
                />
            ),
            label: 'EMERGENCY',
        },
        levelOfConsciousness: {
            icon: (
                <BsFillEmojiDizzyFill
                    style={{
                        height: iconsSize,
                        width: iconsSize,
                        color: '#B46060',
                    }}
                />
            ),
            label: 'EMERGENCY',
        },
        confusion: {
            icon: (
                <ImConfused
                    style={{
                        height: iconsSize,
                        width: iconsSize,
                        color: '#57C4C6',
                    }}
                />
            ),
            label: 'EMERGENCY',
        },
        glucose: {
            icon: (
                <GiMuscleFat
                    style={{
                        height: iconsSize,
                        width: iconsSize,
                        color: '#408E91',
                    }}
                />
            ),
            label: 'EMERGENCY',
        },
        sleep: {
            icon: (
                <GiNightSleep
                    style={{
                        height: iconsSize,
                        width: iconsSize,
                        color: '#2C3848',
                    }}
                />
            ),
            label: 'EMERGENCY',
        },
        steps: {
            icon: (
                <IoFootSteps
                    style={{
                        height: iconsSize,
                        width: iconsSize,
                        color: '#F14E95',
                    }}
                />
            ),
            label: 'EMERGENCY',
        },
        systolic: {
            icon: (
                <Systolic
                    style={{
                        height: iconsSize,
                        width: iconsSize,
                        color: '#CD0404',
                    }}
                />
            ),
            label: 'EMERGENCY',
        },
    }
}
